import responseErrorMessage from '../../../utils/responseErrorMessage';
/* eslint-disable no-nested-ternary */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  Confirm,
  Dimmer,
  Dropdown,
  Grid,
  Icon,
  Input,
  Label,
  Loader,
  Menu,
  Popup,
  Table,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { replace, goBack } from 'react-router-redux';
import { required, numericRange } from '@mhub/web-validations';
import clone from 'clone';
import qs from 'qs';
import config from '../../../../config';
import isNumber from '../../../utils/numbers/isNumber';
import { fullToAmount, spaFullNumber } from '../../../utils/amount';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import MultiUnitCheck from '../../modals/MultiUnitCheck';
import MultiUnitEdit from '../../modals/MultiUnitEdit';
import MultiUnitAllocate from '../../modals/MultiUnitAllocate';
import MultiUnitFormErrors from '../../modals/MultiUnitFormErrors';
import MultiUnitSpecification from '../../modals/MultiUnitSpecification';
import MultiUnitPackagePricing from '../../modals/MultiUnitPackagePricing';
import AppForm from '../../../components/AppForm';
import PageNav from '../../../components/PageNav';
import LoanAmount from '../../../components/LoanAmount';
import SearchMultiUnits from '../../../components/MultiUnits/SearchMultiUnits';
import SelectBank from '../../../components/AppForm/SelectBank';
import { BookingSelectListMultiple } from '../../../components/Filters';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../../actions/flash';
import { UNIT_STATUSES_HQ_ALL, UNIT_STATUSES_EXTERNAL_ALL, UNIT_STATUSES_HQ_BASIC } from '../../../constants/unitStatuses';
import { VA_ACCOUNT_NUMBER, VA_BANK_NAME, VA_UNIT_FIELDS } from '../../../constants/virtualAccount';
import {
  hasVietnamElevatedAccess,
  isAllowedUnitPageLimit,
  isVietnamCompany,
  unitPageLimitOpts,
} from '../../../utils/vietnam';
import { getItem } from '../../../utils/storage';
import {
  ALL_AGENCIES_VALUE,
  ANY_AGENCY_ALLOCATION_FILTER,
  agencyAllocationOptions,
  exclusiveAnyAgencyAllocation,
  resolveAgencyAllocationChange,
} from '../../../utils/agencyAllocation';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class MultiEdit extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    project: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      agencyAllocationAllocateAll: PropTypes.bool,
      projectCurrency: PropTypes.oneOfType([
        PropTypes.array,
      ]),
    }),
    auth: PropTypes.shape({
      onSave: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          virtualAccountIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const page = parseInt(query.page, 10) || 1;
    const pageLimit = query.limit || '50';
    const search = query.search || '';
    const statusID = query.statusID || [];
    const companyBranchID = query.companyBranchID || [];
    const filterUnitLayoutID = query.filterUnitLayoutID || [];
    const filterUnitLevel = query.filterUnitLevel || [];
    let globalSettings = {};
    const storeGloablSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    return {
      currentPage,
      page,
      pageLimit,
      search,
      statusID,
      companyBranchID,
      filterUnitLayoutID,
      filterUnitLevel,
      globalSettings,
    };
  }

  constructor(props) {
    super(props);
    const state = MultiEdit.getPropsToState(props);
    const shiftSelect = { start: null, end: null };
    const checkFunctionData = { a: null, b: null, c: null };
    this.state = {
      ...state,
      count: 0,
      checkFunctionData,
      checkFunctionName: '',
      checkModalIsOpen: false,
      editModalIsOpen: false,
      formErrorModalIsOpen: false,
      isOver: false,
      navHeight: 0,
      isSelectedAll: false,
      limit: 0,
      loading: true,
      offset: 0,
      oriRowsData: [],
      packagePricings: [],
      priceModalIsOpen: false,
      priceModalRow: {},
      rowsData: [],
      shiftSelect,
      sortColumn: null,
      sortDirection: null,
      specModalIsOpen: false,
      specModalRow: {},
      tableWidth: 0,
      unitLayouts: [],
      visibleColumns: ['isBumi', 'streetNumberOrLevel', 'zoneOrBlock', 'streetOrFacing', 'vaBankName', 'vaAccountNumber'],
      companyBranches: [],
      allocateModalIsOpen: false,
      clearAllocationsConfirmIsOpen: false,
      isSectionDisabled: false,
      unitCustomFieldSettings: [],
    };
    this.validation = {};
  }
  componentDidMount() {
    const q = decodeSearch(this.props.location.search);
    const tableTopScrollBar = document.getElementById('tableTopScrollBar');
    const tableBottomScrollBar = document.getElementById('tableBottomScrollBar');
    if (
      !q.limit ||
      !isNumber(q.limit) ||
      q.limit <= 0 ||
      // CPI-1230 (Q1): 300 is accepted for a Vietnamese company only; any other value falls to 50.
      !isAllowedUnitPageLimit(this.props.auth, q.limit)
    ) {
      q.limit = 50;
    }
    this.fetchLayouts();
    this.fetchLevels();
    this.fetchUnitCustomFieldSettings();
    this.replaceQuery(q);
    tableTopScrollBar.addEventListener('scroll', this.onTableScrollBarTop, false);
    tableBottomScrollBar.addEventListener('scroll', this.onTableScrollBarBottom, false);
    window.addEventListener('scroll', this.onScroll, false);
    window.addEventListener('resize', this.onResize, false);
    window.scrollTo(0, 0);
    this.setTableWidth();
    this.fetchPackagePricings();
    this.fetchCompanyBranches();
  }
  componentWillReceiveProps(nextProps) {
    const state = MultiEdit.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentDidUpdate(prevProps) {
    // The project loads after this page mounts on a direct load, so the first fetch could not yet
    // tell whether "Allocate to any" belongs on it.
    if (!prevProps.project && this.props.project) {
      const query = decodeSearch(this.props.location.search);
      if (this.hasStaleAnyAgencyAllocationFilter(query)) {
        this.replaceQuery(query, true);
      }
    }
  }
  componentWillUnmount() {
    if (this.inputScrollbarTimer) {
      clearTimeout(this.inputScrollbarTimer);
    }
    const tableTopScrollBar = document.getElementById('tableTopScrollBar');
    const tableBottomScrollBar = document.getElementById('tableBottomScrollBar');
    tableTopScrollBar.removeEventListener('scroll', this.onTableScrollBarTop, false);
    tableBottomScrollBar.removeEventListener('scroll', this.onTableScrollBarBottom, false);
    window.removeEventListener('scroll', this.onScroll, false);
    window.removeEventListener('resize', this.onResize, false);
    window.scrollTo(0, 0);
  }
  onResize = () => {
    const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width - 15;
    if (tableWidth !== this.state.tableWidth) {
      this.setState({ tableWidth });
    }
    this.setNavHeight();
  }
  onScroll = () => {
    const offsetY = window.pageYOffset;
    const isOver = offsetY > 220;
    if (isOver !== this.state.isOver) {
      this.setState({ isOver });
    }
    this.setNavHeight();
  }
  // The toolbar wraps onto more than one line on narrow screens, so the pinned top scroll bar
  // sits below the toolbar's measured height rather than a fixed one.
  setNavHeight = () => {
    const nav = document.getElementById('multi-edit-nav');
    const navHeight = nav ? nav.getBoundingClientRect().height : 0;
    if (navHeight !== this.state.navHeight) {
      this.setState({ navHeight });
    }
  }
  onTableScrollBarTop = () => {
    const scrollLeft = document.getElementById('tableTopScrollBar').scrollLeft;
    document.getElementById('tableBottomScrollBar').scrollLeft = scrollLeft;
  }
  onTableScrollBarBottom = () => {
    const scrollLeft = document.getElementById('tableBottomScrollBar').scrollLeft;
    document.getElementById('tableTopScrollBar').scrollLeft = scrollLeft;
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setTableWidth = () => {
    const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width - 15;
    this.setState({ tableWidth });
  }
  getCountSummaryText = () => {
    const { rowsData, count, limit, currentPage, statusID, search } = this.state;
    const selectedLength = rowsData.filter(d => d.isSelected).length;
    const totalPages = Math.ceil(count / limit);
    const startUnit = ((currentPage * limit) - limit) + 1;
    const isAllStatusID = statusID && statusID.includes('all');

    let endUnit = (currentPage * limit);
    if (currentPage === totalPages) {
      endUnit = count;
    }
    return (
      <span>{this.props.t('Showing', { ns: TRANSLATION_FILES.translation })} {rowsData.length > 0 ? `${startUnit}-${endUnit}` : '0'} {this.props.t('of', { ns: TRANSLATION_FILES.translation })} {count} {search !== '' ? <span>{this.props.t('results for', { ns: TRANSLATION_FILES.translation })} <b>{search}</b></span> : this.props.t('units', { ns: TRANSLATION_FILES.translation })}
        {!isAllStatusID ? ` ${this.props.t('from')} ${this.getValueName(statusID, this.SEARCH_STATUSES)}` : ''}
        {selectedLength > 0 ? <span>, <b>{selectedLength} {this.props.t('selected', { ns: TRANSLATION_FILES.translation })}</b></span> : ''}
        {(!isAllStatusID || search !== '') ?
          <span>
            &nbsp;|&nbsp;
            <button
              className="a-button-blue"
              onClick={e => this.handleTriggerCheck('handleClearFilter', e)}
            >
              <Icon name="remove" fitted /> {this.props.t('Clear Filter', { ns: TRANSLATION_FILES.translation })}
            </button>
          </span>
           : ''}
      </span>
    );
  }
  getFormatedSPAValue = (oldValue, newValue, type) => {
    if (type === 'increase') {
      return Math.round(oldValue + ((newValue / 100) * oldValue));
    }
    if (type === 'deduct') {
      return Math.round(oldValue - ((newValue / 100) * oldValue));
    }
    return newValue;
  }
  getRowClassName = (isSelected, rowID) => {
    if (this.checkIfRowError(rowID)) return 'red';
    if (!isSelected && !this.checkIfRowError(rowID) && this.checkIfRowChanged(rowID)) return 'green';
    return '';
  }
  getSelectedRowsData() {
    return this.state.rowsData.filter(d => d.isSelected);
  }
  getValueName = (value, arr) => {
    const valueName = arr.filter(vn => value.some(v => v === vn.value)).map(x => x.text);
    if (valueName) {
      return valueName.join(', ');
    }
    return '';
  }
  setVAFieldValue = (id, data) => {
    if (id === VA_BANK_NAME) {
      return data.vaBankName;
    }
    if (id === VA_ACCOUNT_NUMBER) {
      return data.vaAccountNumber;
    }
    return '';
  }
  async fetchPackagePricings() {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/package_pricings/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      const packagePricings = json;
      await this.setComponentState({
        packagePricings,
      });
    }
    await this.setLoading(false);
  }
  async fetchCompanyBranches() {
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/accessible_company_branches/?isExternal=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await responseErrorMessage(res);
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const data = json.map((obj) => {
          const newResults = {};
          newResults.text = obj.name;
          newResults.value = obj.id;
          return newResults;
        });
        this.fetchedCompanyBranches = data;
        await this.setComponentState({
          companyBranches: data,
        });
      }
    }
  }
  async fetchLayouts() {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/search/project_unit_layouts/?projectID=${this.props.params.id}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const data = json.map((obj, idx) => {
          const newResults = {};
          newResults.key = idx;
          newResults.value = obj.id;
          newResults.text = obj.name;
          return newResults;
        });
        this.fetchedUnitLayouts = data;
        await this.setComponentState({
          unitLayouts: data,
        });
      }
    }
    await this.setLoading(false);
  }
  async fetchLevels() {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/units/levels/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        // the endpoint scans into []string, so a unit with no level arrives as ''
        // rather than null, and would otherwise show up as a blank dropdown entry
        this.fetchedUnitLevels = json
          .filter(val => val !== '')
          .map((val, idx) => {
            const newResults = {};
            newResults.key = idx;
            newResults.value = val;
            newResults.text = val;
            return newResults;
          });
      }
    }
    await this.setLoading(false);
  }
  async fetchUnitCustomFieldSettings() {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/unit_custom_fields/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const unitCustomFieldSettingsData = await res.json();
      await this.setComponentState({
        unitCustomFieldSettings: unitCustomFieldSettingsData,
      });
      await this.setLoading(false);
    }
  }
  async fetchUnits(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (
      !query.limit ||
      !isNumber(query.limit) ||
      query.limit <= 0 ||
      !isAllowedUnitPageLimit(this.props.auth, query.limit)
    ) {
      query.limit = 50;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/units/bulk/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      const { t } = this.props;
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const token = res.headers.get('X-Csrf-Token');
      const json = await res.json();
      let data = json;
      if (data) {
        let i = 1;
        data.forEach((d, idx) => {
          data[idx].isSelected = false;
          data[idx].rowID = i;
          data[idx].size = data[idx].size.toString();
          data[idx].spaValue = data[idx].spaValue.toString();
          data[idx].position = data[idx].position.toString();
          data[idx].spaAmount = spaFullNumber(data[idx]) || data[idx].spaValue; // decimal amount
          // virtual account
          if (d.projectUnitCustomFields) {
            const vaBankName = data[idx].projectUnitCustomFields.find(pucf => pucf.projectUnitCustomFieldSettingID === VA_BANK_NAME);
            const vaAccountNo = data[idx].projectUnitCustomFields.find(pucf => pucf.projectUnitCustomFieldSettingID === VA_ACCOUNT_NUMBER);
            data[idx].vaBankName = vaBankName ? vaBankName.value : '';
            data[idx].vaAccountNumber = vaAccountNo ? vaAccountNo.value : '';
          }
          data[idx].errors = {
            reference: '',
            size: '',
            spaAmount: '',
            position: '',
          };
          i += 1;
        });
        this.setState({ isSectionDisabled: false });
      } else {
        data = [];
        this.setState({ filterUnitLevel: [], isSectionDisabled: true });
      }
      await this.setComponentState({
        count,
        limit,
        offset,
        token,
        oriRowsData: clone(data),
        rowsData: data,
      });
    }
    await this.setLoading(false);
  }
  async updateUnits() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, decodeSearch(this.props.location.search));
    const { oriRowsData, rowsData, unitCustomFieldSettings } = this.state;
    const newRowsData = [];
    const hasErrors = rowsData.find(d => d.errors.reference !== '' || d.errors.size !== '' || d.errors.spaAmount !== '' || d.errors.position !== '');
    if (hasErrors) {
      await this.setLoading(false);
      this.setState({ formErrorModalIsOpen: true });
      return;
    }
    if (
      !query.limit ||
      !isNumber(query.limit) ||
      query.limit <= 0 ||
      !isAllowedUnitPageLimit(this.props.auth, query.limit)
    ) {
      query.limit = 50;
    }
    rowsData.forEach((d) => {
      const oriRow = oriRowsData.find(r => r.rowID === d.rowID);
      const row = d;
      delete row.isSelected;
      delete oriRow.isSelected;
      try {
        if (JSON.stringify(row) !== JSON.stringify(oriRow)) {
          newRowsData.push(row);
        }
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    });
    newRowsData.forEach((d, idx) => {
      newRowsData[idx].size = parseFloat(newRowsData[idx].size);
      newRowsData[idx].spaValue = parseInt(newRowsData[idx].spaAmount, 10);
      newRowsData[idx].position = parseInt(newRowsData[idx].position, 10);
      if (d.projectUnitPackagePricings) {
        newRowsData[idx].projectUnitPackagePricings = d.projectUnitPackagePricings.map(p => Object.assign(p, {
          totalPrice: parseFloat(p.totalPrice), // decimal amount
        }));
      }

      const customFields = [];
      if (d.projectUnitCustomFields) {
        d.projectUnitCustomFields.forEach((p) => {
          if (VA_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
            p.value = this.setVAFieldValue(p.projectUnitCustomFieldSettingID, newRowsData[idx]);
          }
          customFields.push(p);
        });
      }
      if (unitCustomFieldSettings) {
        unitCustomFieldSettings.forEach((u) => {
          let exists = -1;
          if (d.projectUnitCustomFields) exists = d.projectUnitCustomFields.findIndex(ucfData => ucfData.projectUnitCustomFieldSettingID === u.id);
          if (exists === -1) {
            if (VA_UNIT_FIELDS.includes(u.id)) {
              const customField = {
                value: this.setVAFieldValue(u.id, newRowsData[idx]),
                projectUnitCustomFieldSettingID: u.id,
                projectUnitCustomFieldSetting: u,
              };
              customFields.push(customField);
            }
          }
        });
      }
      newRowsData[idx].projectUnitCustomFields = customFields;

      newRowsData[idx] = fullToAmount(
        newRowsData[idx], newRowsData[idx].spaAmount,
      ); // decimal amount
    });
    if (newRowsData.length === 0) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ header: t('No Units To Update', { ns: TRANSLATION_FILES.translation }), message: t('No changes found.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    try {
      await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/units/bulk/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(newRowsData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    await this.replaceQuery(query, false, true);
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('{{count}} Units successfully updated.', { count: newRowsData.length, ns: TRANSLATION_FILES.translation }) }));
  }
  // CPI-288: release every agency from ALL Available units of the project. Deliberately not the
  // row-diff PUT updateUnits() sends - the set is not client-enumerable, so the server owns it.
  async clearAllAllocations() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, decodeSearch(this.props.location.search));
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.params.id}/units/release_allocations/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify({}),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    let releasedCount = 0;
    try {
      const json = await res.json();
      if (json && typeof json.released_count === 'number') {
        releasedCount = json.released_count;
      }
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    await this.setLoading(false);
    // replaceQuery is async on this branch (MS-6522); resetChanges drops the stale dirty-row state.
    await this.replaceQuery(query, false, true);
    store.dispatch(flashSuccessMessage({
      header: t('Allocations Cleared', { ns: TRANSLATION_FILES.translation }),
      message: t('Agency allocations were cleared for {{count}} Available units.', { count: releasedCount, ns: TRANSLATION_FILES.translation }),
    }));
  }
  async replaceQuery(query, resetPage = false, resetChanges = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    if (this.hasStaleAnyAgencyAllocationFilter(queryNew)) {
      const companyBranchID = BookingSelectListMultiple.toValueArray(queryNew.companyBranchID)
        .filter(value => value !== ANY_AGENCY_ALLOCATION_FILTER);
      if (companyBranchID.length > 0) {
        queryNew.companyBranchID = companyBranchID;
      } else {
        delete queryNew.companyBranchID;
      }
    }
    this.setState({ isSelectedAll: false, sortColumn: null, sortDirection: null });
    await this.fetchUnits(queryNew);
    if (resetChanges) {
      this.handleOnCheck(false);
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  filterPackingPricing = (packages) => {
    const { packagePricings } = this.state;
    const newPackagePricings = packages;
    if (packagePricings) {
      packages.forEach((pt, idx) => {
          // expired schedule
        const sStart = pt.scheduleStartAt;
        const sEnd = pt.scheduleEndAt;
        if ((sStart && moment(sStart).unix() > moment().unix()) ||
          (sEnd && moment(sEnd).unix() < moment().unix())) {
          newPackagePricings[idx].disabled = true;
        }
      });
    }
    return newPackagePricings;
  }
  getValueDropdown = (array, value) => {
    const element = array.find(a => a.value == value);
    if (element && element.text) {
      return element.value;
    }
    return '';
  }
  // MS-6522: the project's own setting, else the global one, read the same way in every country.
  isAgencyAllocationAllocateAll = () => {
    const projectSetting = this.props.project && this.props.project.agencyAllocationAllocateAll;
    return typeof projectSetting === 'boolean' ?
      projectSetting : Boolean(this.state.globalSettings.agencyAllocationAllocateAll);
  }
  // "Allocate to any" is offered on "Allocate to none" only; a link carrying it onto an
  // "Allocate to all" project would filter by an option the page no longer shows. Judged only once
  // the project has loaded, as the global setting alone can be overridden by the project's own.
  hasStaleAnyAgencyAllocationFilter = query => Boolean(this.props.project)
    && this.isAgencyAllocationAllocateAll()
    && BookingSelectListMultiple.toValueArray(query.companyBranchID)
      .includes(ANY_AGENCY_ALLOCATION_FILTER)
  getAgencyAllocationOptions = (column, companyBranches, agencyAllocationAllocateAll) => {
    const allocationIDs = column.companyBranchAllocationIDs || [];
    return agencyAllocationOptions({
      companyBranches,
      allocationIDs,
      showAllAgencies: agencyAllocationAllocateAll && allocationIDs.length === 0,
      t: this.props.t,
    });
  }
  renderAgencyLabel = item => ({ content: item.text, active: false });
  getAgencyAllocationValue = (column, agencyAllocationAllocateAll) => {
    const allocationIDs = column.companyBranchAllocationIDs || [];
    return agencyAllocationAllocateAll && allocationIDs.length === 0 ?
      [ALL_AGENCIES_VALUE] : allocationIDs;
  }
  handleInputChange = (event, data, rowID) => {
    const { rowsData, oriRowsData } = this.state;
    if (
      data.name === 'reference' ||
      data.name === 'size' ||
      data.name === 'spaAmount' ||
      data.name === 'position'
    ) {
      this.validation[`${data.name}${rowID}`].current.validate(data.value);
    }
    const index = rowsData.findIndex(r => r.rowID === rowID);
    const nextValue = data.name === 'companyBranchAllocationIDs' && Array.isArray(data.value) ?
      resolveAgencyAllocationChange(data.value, this.state.companyBranches) : data.value;
    const originalValue = oriRowsData[index][data.name];
    rowsData[index][data.name] = data.name === 'companyBranchAllocationIDs'
      && Array.isArray(nextValue)
      && nextValue.length === 0
      && (!originalValue || originalValue.length === 0)
      ? originalValue : nextValue;
    this.setState({ rowsData, sortColumn: null, sortDirection: null }, () => {
      this.handleOnCheck(true);
      if (
        data.name === 'reference' ||
        data.name === 'size' ||
        data.name === 'spaAmount' ||
        data.name === 'position'
      ) {
        this.inputScrollbarTimer = setTimeout(() => {
          const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
          if (tableWidth !== this.state.tableWidth) {
            this.setState({ tableWidth });
          }
        }, 500);
      }
    });
  }
  handleTextAreaChange = (event, rowID) => {
    const { rowsData } = this.state;
    const index = rowsData.findIndex(r => r.rowID === rowID);
    rowsData[index][event.target.name] = event.target.value;
    this.setState({ rowsData, sortColumn: null, sortDirection: null }, () => {
      this.handleOnCheck(true);
    });
  }
  handleCheckboxChange = (event, data, rowID) => {
    const { rowsData } = this.state;
    const index = rowsData.findIndex(r => r.rowID === rowID);
    rowsData[index][data.name] = !rowsData[index][data.name];
    this.setState({ rowsData, sortColumn: null, sortDirection: null }, () => {
      this.handleOnCheck(true);
    });
  }
  handleCheckboxClick = (event, rowID) => {
    const { shiftSelect, rowsData } = this.state;
    const index = rowsData.findIndex(r => r.rowID === rowID);
    if (event.shiftKey) {
      if (rowsData[shiftSelect.start].isSelected !== rowsData[index].isSelected) {
        shiftSelect.end = null;
      }
      if (shiftSelect.start === null) {
        shiftSelect.start = index;
      }
      if (shiftSelect.start !== index) {
        if (shiftSelect.start > index) {
          rowsData.forEach((d, idx) => {
            if (idx >= index && idx <= shiftSelect.start) {
              rowsData[idx].isSelected = rowsData[shiftSelect.start].isSelected;
            }
            if (shiftSelect.end && idx >= shiftSelect.end && idx <= index) {
              rowsData[idx].isSelected = !rowsData[shiftSelect.start].isSelected;
            }
          });
        }
        if (shiftSelect.start < index) {
          rowsData.forEach((d, idx) => {
            if (idx >= shiftSelect.start && idx <= index) {
              rowsData[idx].isSelected = rowsData[shiftSelect.start].isSelected;
            }
            if (shiftSelect.end && idx >= index && idx <= shiftSelect.end) {
              rowsData[idx].isSelected = !rowsData[shiftSelect.start].isSelected;
            }
          });
        }
        shiftSelect.end = index;
      } else {
        rowsData[index].isSelected = !rowsData[index].isSelected;
      }
    } else {
      rowsData[index].isSelected = !rowsData[index].isSelected;
      shiftSelect.start = index;
      shiftSelect.end = null;
    }
    this.setState({ shiftSelect, rowsData, isSelectedAll: false });
  }
  handleCheckboxSelectAll = () => {
    const { shiftSelect, rowsData } = this.state;
    const isSelectedAll = !this.state.isSelectedAll;
    shiftSelect.start = null;
    shiftSelect.end = null;
    rowsData.forEach((d, idx) => {
      rowsData[idx].isSelected = !this.state.isSelectedAll;
    });
    this.setState({ shiftSelect, rowsData, isSelectedAll });
  }
  handleManageSpecifications = (e, row) => {
    e.preventDefault();
    this.setState({ specModalIsOpen: true, specModalRow: row });
  }
  handleSpecificationsOnDone = () => {
    this.setState({ specModalIsOpen: false, specModalRow: {} });
  }
  handleSpecificationsOnChange = (data) => {
    const { rowsData, specModalRow } = this.state;
    if (specModalRow) {
      const index = rowsData.findIndex(r => r.rowID === specModalRow.rowID);
      rowsData[index].specifications = data;
    }
    this.setState({ rowsData }, () => {
      this.handleOnCheck(true);
      this.inputScrollbarTimer = setTimeout(() => {
        const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
        if (tableWidth !== this.state.tableWidth) {
          this.setState({ tableWidth });
        }
      }, 500);
    });
  }
  handleManageAllocate = () => {
    this.setState({ allocateModalIsOpen: true });
  }
  handleClearAllocations = (e) => {
    e.preventDefault();
    this.setState({ clearAllocationsConfirmIsOpen: true });
  }
  handleCancelClearAllocations = () => {
    this.setState({ clearAllocationsConfirmIsOpen: false });
  }
  handleConfirmClearAllocations = () => {
    this.setState({ clearAllocationsConfirmIsOpen: false }, () => {
      this.clearAllAllocations();
    });
  }
  handleManagePricing = (e, row) => {
    e.preventDefault();
    this.setState({ priceModalIsOpen: true, priceModalRow: row });
  }
  handlePricingOnDone = () => {
    this.setState({ priceModalIsOpen: false, priceModalRow: {} });
  }
  handlePricingOnChange = (data) => {
    const { rowsData, priceModalRow } = this.state;
    if (priceModalRow) {
      const index = rowsData.findIndex(r => r.rowID === priceModalRow.rowID);
      rowsData[index].projectUnitPackagePricings = data;
    }
    this.setState({ rowsData }, () => {
      this.handleOnCheck(true);
      this.inputScrollbarTimer = setTimeout(() => {
        const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
        if (tableWidth !== this.state.tableWidth) {
          this.setState({ tableWidth });
        }
      }, 500);
    });
  }
  handleVisibleCheckboxChange = (event, data) => {
    const { visibleColumns } = this.state;
    if (this.checkIfColumnVisible(data.name)) {
      visibleColumns.splice(visibleColumns.findIndex(d => d === data.name), 1);
    } else {
      visibleColumns.push(data.name);
    }
    this.setState({ visibleColumns }, () => {
      const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
      if (tableWidth !== this.state.tableWidth) {
        this.setState({ tableWidth });
      }
    });
  }
  handleCellSort = (column) => {
    const { rowsData, oriRowsData, sortColumn, sortDirection } = this.state;
    let direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    let sortedArray = rowsData;
    let oriSortedArray = oriRowsData;
    if (direction === 'asc') {
      sortedArray = rowsData.sort((a, b) => {
        if (a[column] < b[column]) return -1;
        if (a[column] > b[column]) return 1;
        return 0;
      });
      oriSortedArray = oriRowsData.sort((a, b) => {
        if (a[column] < b[column]) return -1;
        if (a[column] > b[column]) return 1;
        return 0;
      });
    }
    if (direction === 'desc') {
      sortedArray = rowsData.sort((a, b) => {
        if (b[column] < a[column]) return -1;
        if (b[column] > a[column]) return 1;
        return 0;
      });
      oriSortedArray = oriRowsData.sort((a, b) => {
        if (b[column] < a[column]) return -1;
        if (b[column] > a[column]) return 1;
        return 0;
      });
    }
    this.setState({
      rowsData: sortedArray,
      oriRowsData: oriSortedArray,
      sortColumn: column,
      sortDirection: direction,
    });
  }
  cellCheckSorted(column) {
    const { sortColumn, sortDirection } = this.state;
    if (column === sortColumn) {
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  sortArray = (array, column) => {
    const sortedArray = array.sort((a, b) => {
      if (a[column] < b[column]) return -1;
      if (a[column] > b[column]) return 1;
      return 0;
    });
    return sortedArray;
  }
  checkIfAnySelected = () => {
    const { rowsData } = this.state;
    const selected = rowsData.find(d => d.isSelected);
    if (selected) return true;
    return false;
  }
  checkIfColumnVisible = (column) => {
    const found = this.state.visibleColumns.find(d => d === column);
    if (found) return true;
    return false;
  }
  checkRestrictedStatusID = (statusID) => {
    if (statusID === 'reserved' ||
      statusID === 'booked' ||
      statusID === 'sold_spa_signed'
    ) {
      return true;
    }
    return false;
  }
  isAgencyAllocationLocked = statusID =>
    isVietnamCompany(this.props.auth) && this.checkRestrictedStatusID(statusID);
  updateRowsData = (rowsData, field, value) => {
    const newRowsData = rowsData;
    rowsData.filter(d => d.isSelected).forEach((data) => {
      const index = rowsData.findIndex(r => r.rowID === data.rowID);
      const statusID = newRowsData[index].statusID;
      if ((field === 'statusID' || field === 'spaAmount') && (
        statusID === 'new' ||
        statusID === 'developer_reserved' ||
        statusID === 'developer_booked' ||
        statusID === 'developer_sold' ||
        statusID === 'delist'
      )) {
        if (field === 'statusID') {
          newRowsData[index][field] = value;
        }
        if (field === 'spaAmount') {
          newRowsData[index][field] = this.getFormatedSPAValue(
            parseFloat(newRowsData[index][field]),
            parseFloat(value.value),
            value.type,
          );
        }
      } else if (field === 'companyBranchAllocationIDs') {
        if (!this.isAgencyAllocationLocked(statusID)) {
          newRowsData[index][field] = value;
        }
      } else if (field !== 'statusID' && field !== 'spaAmount') {
        newRowsData[index][field] = value;
      }
    });
    return newRowsData;
  }
  handleChangeLimit = (e, data) => {
    const query = decodeSearch(this.props.location.search);
    query.limit = data.value;
    this.setState({ pageLimit: data.value }, () => {
      this.replaceQuery(query, true);
    });
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleClearFilter = (e) => {
    e.preventDefault();
    const query = decodeSearch(this.props.location.search);
    ['search', 'statusID', 'filterUnitLevel', 'filterUnitLayoutID', 'companyBranchID']
      .forEach((key) => { delete query[key]; });
    this.replaceQuery(query, true);
  }
  handleSearchOnSubmit = (search) => {
    const query = decodeSearch(this.props.location.search);
    query.search = search;
    if (search === '') {
      delete query.search;
    }
    if ((search !== this.state.search) || this.state.search !== '') {
      this.setState({ search }, () => {
        this.replaceQuery(query, true);
      });
    }
  }
  handleTriggerCheck = (checkFunctionName, a = null, b = null, c = null) => {
    const { rowsData, oriRowsData } = this.state;
    let match = false;
    let checkModalIsOpen = true;
    try {
      match = (JSON.stringify(rowsData) === JSON.stringify(oriRowsData));
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    if (match) checkModalIsOpen = false;
    const checkFunctionData = { a, b, c };
    this.setState({ checkModalIsOpen, checkFunctionData, checkFunctionName }, () => {
      if (match) this.handleConfirmCheckModal();
    });
  }
  handleConfirmCheckModal = () => {
    const { checkFunctionData, checkFunctionName } = this.state;
    switch (checkFunctionName) {
      case 'handleChangeLimit':
        this.handleChangeLimit(checkFunctionData.a, checkFunctionData.b);
        break;
      case 'handleChangePage':
        this.handleChangePage(checkFunctionData.a);
        break;
      case 'handleClearFilter':
        this.handleClearFilter(checkFunctionData.a);
        break;
      case 'handleSearchOnSubmit':
        this.handleSearchOnSubmit(checkFunctionData.a);
        break;
      default:
        break;
    }
    checkFunctionData.a = null;
    checkFunctionData.b = null;
    checkFunctionData.c = null;
    this.setState({ checkModalIsOpen: false, checkFunctionData, checkFunctionName: '' });
  }
  handleFilterOnChange = (filterValue, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const arrValue = queryName === 'companyBranchID' ?
      exclusiveAnyAgencyAllocation(filterValue) : filterValue;
    query[queryName] = arrValue;
    if (arrValue.includes('all')) {
      delete query[queryName];
    }
    this.setState({ [queryName]: arrValue });
    this.replaceQuery(query, true);
  };
  handleCancelCheckModal = () => {
    const checkFunctionData = { a: null, b: null, c: null };
    this.setState({ checkModalIsOpen: false, checkFunctionData, checkFunctionName: '' });
  }
  handleEditRow = () => {
    this.setState({ editModalIsOpen: true });
  }
  handleModalSave = async (closeModal, selectedEditField, fieldValue) => {
    const { visibleColumns } = this.state;
    let { editModalIsOpen, allocateModalIsOpen, rowsData, isSelectedAll } = this.state;
    if (selectedEditField !== '' && fieldValue !== '') {
      rowsData = this.updateRowsData(rowsData, selectedEditField, fieldValue);
    }
    if (closeModal) {
      editModalIsOpen = false;
      allocateModalIsOpen = false;
      isSelectedAll = false;
      rowsData.forEach((d, idx) => {
        if (d.isSelected) {
          rowsData[idx].isSelected = false;
        }
      });
    }
    if (selectedEditField === 'specifications' && !this.checkIfColumnVisible('specifications')) {
      visibleColumns.push('specifications');
    }
    if (selectedEditField === 'packagePricings' && !this.checkIfColumnVisible('packagePricings')) {
      visibleColumns.push('packagePricings');
    }
    this.setState({ editModalIsOpen, allocateModalIsOpen, isSelectedAll, rowsData, visibleColumns });
  }
  handleCloseEditModal = () => {
    this.setState({ editModalIsOpen: false });
  }
  handleCloseAllocate = () => {
    this.setState({ allocateModalIsOpen: false });
  }
  handleCloseFormErrorModal = () => {
    this.setState({ formErrorModalIsOpen: false });
  }
  handleOnDeselectUnit = (e, rowID) => {
    const { rowsData } = this.state;
    const index = rowsData.findIndex(r => r.rowID === rowID);
    rowsData[index].isSelected = false;
    this.setState({ rowsData, isSelectedAll: false });
  }
  checkIfRowChanged = (rowID) => {
    const { rowsData, oriRowsData } = this.state;
    const row = Object.assign({}, rowsData[rowsData.findIndex(r => r.rowID === rowID)]);
    const oriRow = Object.assign({}, oriRowsData[oriRowsData.findIndex(r => r.rowID === rowID)]);
    delete row.isSelected;
    delete oriRow.isSelected;
    try {
      if (JSON.stringify(row) !== JSON.stringify(oriRow)) return true;
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    return false;
  }
  checkIfRowError = (rowID) => {
    const { rowsData } = this.state;
    const d = Object.assign({}, rowsData[rowsData.findIndex(r => r.rowID === rowID)]);
    if (
      d.errors.reference !== '' ||
      d.errors.size !== '' ||
      d.errors.spaAmount !== '' ||
      d.errors.position !== ''
    ) {
      return true;
    }
    return false;
  }
  handleResetRow = () => {
    const { rowsData, oriRowsData } = this.state;
    rowsData.forEach((d, idx) => {
      if (d.isSelected) {
        const oriRow = oriRowsData.find(r => r.rowID === d.rowID);
        rowsData[idx].isSelected = false;
        rowsData[idx].projectUnitLayoutID = oriRow.projectUnitLayoutID;
        rowsData[idx].reference = oriRow.reference;
        rowsData[idx].statusID = oriRow.statusID;
        rowsData[idx].size = oriRow.size;
        rowsData[idx].spaAmount = oriRow.spaAmount;
        rowsData[idx].isBumi = oriRow.isBumi;
        rowsData[idx].address = oriRow.address;
        rowsData[idx].position = oriRow.position;
        rowsData[idx].zoneOrBlock = oriRow.zoneOrBlock;
        rowsData[idx].streetNumberOrLevel = oriRow.streetNumberOrLevel;
        rowsData[idx].streetOrFacing = oriRow.streetOrFacing;
        rowsData[idx].remarkExternal = oriRow.remarkExternal;
        rowsData[idx].remarkInternal = oriRow.remarkInternal;
        rowsData[idx].projectUnitPackagePricings = oriRow.projectUnitPackagePricings;
        rowsData[idx].specifications = oriRow.specifications;
        rowsData[idx].errors = oriRow.errors;
        rowsData[idx].vaBankName = oriRow.vaBankName;
        rowsData[idx].vaAccountNumber = oriRow.vaAccountNumber;
      }
    });
    this.setState({
      rowsData,
      isSelectedAll: false,
      sortColumn: null,
      sortDirection: null,
    }, () => {
      const tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
      if (tableWidth !== this.state.tableWidth) {
        this.setState({ tableWidth });
      }
    });
  }
  handleGoBack = (e) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(goBack());
  }
  handleOnError = (hasError, errorMessage, inputName, rowID) => {
    const { rowsData } = this.state;
    const index = rowsData.findIndex(r => r.rowID === rowID);
    if (hasError) {
      rowsData[index].errors[inputName] = errorMessage;
    } else {
      rowsData[index].errors[inputName] = '';
    }
    this.setState({ rowsData });
  }
  handleOnCheck = (hasChanges = false, callback) => {
    const { rowsData, oriRowsData } = this.state;
    let match = false;
    try {
      match = (JSON.stringify(rowsData) === JSON.stringify(oriRowsData));
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    if (this.props.onCheck) {
      if (match) {
        this.props.onCheck(false, callback);
        return;
      }
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleUpdateUnits = (e) => {
    e.preventDefault();
    this.updateUnits();
  }
  hasVAEnabled = () => {
    const { appConfig } = this.props;
    return appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.virtualAccountIsEnabled;
  }
  PAGE_LIMITS = [
    { text: '25', value: '25' },
    { text: '50', value: '50' },
    { text: '100', value: '100' },
    { text: '150', value: '150' },
  ]
  getPageLimits = () => unitPageLimitOpts(this.props.auth, this.PAGE_LIMITS)
  getSearchStatuses = () => [
    { text: this.props.t('All Status', { ns: TRANSLATION_FILES.translation }), value: 'all' },
    ...UNIT_STATUSES_HQ_BASIC,
  ]
  // Options loaded from the API. They are held here rather than inside the getters
  // below, which rebuild their array on every read so the "All ..." labels pick up a
  // language change — anything pushed into that array would be thrown away with it.
  fetchedCompanyBranches = []
  fetchedUnitLayouts = []
  fetchedUnitLevels = []
  getSearchCompanyBranch = () => [
    { text: this.props.t('All Agency', { ns: TRANSLATION_FILES.translation }), value: 'all' },
    ...(this.isAgencyAllocationAllocateAll() ? [] : [{
      text: this.props.t('Allocate to any', { ns: TRANSLATION_FILES.translation }),
      value: ANY_AGENCY_ALLOCATION_FILTER,
    }]),
    ...this.fetchedCompanyBranches,
  ]
  getSearchUnitLayouts = () => [
    { text: this.props.t('All Type', { ns: TRANSLATION_FILES.translation }), value: 'all' },
    ...this.fetchedUnitLayouts,
  ]
  getSearchUnitLevel = () => [
    { text: this.props.t('All Level', { ns: TRANSLATION_FILES.translation }), value: 'all' },
    ...this.fetchedUnitLevels,
  ]
  get SEARCH_STATUSES() {
    return this.getSearchStatuses();
  }
  get SEARCH_COMPANY_BRANCH() {
    return this.getSearchCompanyBranch();
  }
  get SEARCH_UNITLAYOUTS() {
    return this.getSearchUnitLayouts();
  }
  get SEARCH_UNITLEVEL() {
    return this.getSearchUnitLevel();
  }
  render() {
    const {
      allowEditUnitDetails,
      allowEditUnitPrice,
      company,
    } = this.props.auth;
    const { t } = this.props;
    const {
      checkModalIsOpen,
      editModalIsOpen,
      formErrorModalIsOpen,
      priceModalIsOpen,
      rowsData,
      specModalIsOpen,
      companyBranches,
      allocateModalIsOpen,
      clearAllocationsConfirmIsOpen,
      globalSettings,
    } = this.state;
    // On "Allocate to all" an unallocated unit reads as "All Agencies" below; on "Allocate to none"
    // it reads as allocated to nobody, and the developer assigns an agency explicitly.
    const agencyAllocationAllocateAll = this.isAgencyAllocationAllocateAll();
    const getFilteredPackage = this.state.packagePricings ? this.filterPackingPricing(this.state.packagePricings).filter(data => data.disabled !== true) : null;
    const isMalaysia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'MY';
    // CPI-288: HQ & Sales Admin only, in every country. Shipped Vietnam-only and later opened to
    // Malaysia and Indonesia together with the server gate. The role test is the same
    // "HQ or Sales Admin" family hasVietnamElevatedAccess encodes; not ANDed with
    // allowEditUnitDetails, as the server's gate tests the role only.
    const canClearAllocations = hasVietnamElevatedAccess(this.props.auth);
    if (rowsData.length > 0) {
      rowsData.forEach((column) => {
        this.validation[`reference${column.rowID}`] = createRef();
        this.validation[`size${column.rowID}`] = createRef();
        this.validation[`position${column.rowID}`] = createRef();
        this.validation[`spaAmount${column.rowID}`] = createRef();
      });
    }
    return (
      <Grid>
        <Grid.Row style={{ paddingTop: '0.5em' }}>
          <Grid.Column>
            <Menu
              fluid secondary
              style={{ margin: 'auto 2em', paddingBottom: '0.5em' }}
            >
              <Menu.Item
                link
                href="/"
                icon="left chevron"
                onClick={this.handleGoBack}
              />
              <Menu.Item header content={this.props.t('Edit Units', { ns: TRANSLATION_FILES.translation })} />
            </Menu>
            <Grid style={{ margin: 'auto 1em' }}>
              <Dimmer active={this.state.loading} inverted>
                <Loader inverted className="multi-edit-loading" >{this.props.t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <MultiUnitEdit
                onClose={this.handleCloseEditModal}
                onDeselectUnit={this.handleOnDeselectUnit}
                onSave={this.handleModalSave}
                open={editModalIsOpen}
                projectUnitLayouts={this.state.unitLayouts}
                packagePricings={getFilteredPackage || []}
                selectedRowsData={this.getSelectedRowsData()}
                allowEditUnitPrice={allowEditUnitPrice}
                allowEditUnitDetails={allowEditUnitDetails}
                sellingPriceCustomName={globalSettings && globalSettings.sellingPrice}
                vaIsEnabled={this.hasVAEnabled()}
                countryCode={company ? company.countryCode : ''}
              />
              <MultiUnitPackagePricing
                onChange={this.handlePricingOnChange}
                onDone={this.handlePricingOnDone}
                open={priceModalIsOpen}
                unit={this.state.priceModalRow}
                packagePricings={getFilteredPackage || []}
              />
              <MultiUnitSpecification
                onChange={this.handleSpecificationsOnChange}
                onDone={this.handleSpecificationsOnDone}
                open={specModalIsOpen}
                unit={this.state.specModalRow}
              />
              <MultiUnitCheck
                onCancel={this.handleCancelCheckModal}
                onConfirm={this.handleConfirmCheckModal}
                open={checkModalIsOpen}
              />
              <MultiUnitFormErrors
                onClose={this.handleCloseFormErrorModal}
                open={formErrorModalIsOpen}
                data={rowsData}
              />
              <MultiUnitAllocate
                onClose={this.handleCloseAllocate}
                onDeselectUnit={this.handleOnDeselectUnit}
                onSave={this.handleModalSave}
                open={allocateModalIsOpen}
                businessUnit={companyBranches}
                selectedRowsData={this.getSelectedRowsData()
                  .filter(row => !this.isAgencyAllocationLocked(row.statusID))}
                lockedRowsData={this.getSelectedRowsData()
                  .filter(row => this.isAgencyAllocationLocked(row.statusID))}
                allowEditUnitDetails={allowEditUnitDetails}
                agencyAllocationAllocateAll={agencyAllocationAllocateAll}
              />
              {
                canClearAllocations && (
                  <Confirm
                    open={clearAllocationsConfirmIsOpen}
                    header={t('Clear all agency allocations?', { ns: TRANSLATION_FILES.translation })}
                    content={t('This clears every agency from ALL Available units in this project. Reserved, booked and sold units keep their agencies. This cannot be undone.', { ns: TRANSLATION_FILES.translation })}
                    cancelButton={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                    confirmButton={t('Release all', { ns: TRANSLATION_FILES.translation })}
                    onCancel={this.handleCancelClearAllocations}
                    onConfirm={this.handleConfirmClearAllocations}
                  />
                )
              }
              <Grid.Row style={{ paddingBottom: '0', paddingTop: '0' }}>
                <Grid.Column
                  id="multi-edit-nav"
                  className={`multi-edit-nav ${this.state.isOver ? 'fixed' : ''}`}
                >
                  <Menu stackable>
                    <Dropdown item text={this.props.t('Columns', { ns: TRANSLATION_FILES.translation })} simple basic>
                      <Dropdown.Menu>
                        {
                          isMalaysia && (
                            <Dropdown.Item
                              name="isBumi"
                              onClick={this.handleVisibleCheckboxChange}
                            >
                              <Checkbox
                                checked={this.checkIfColumnVisible('isBumi')}
                                label={this.props.t('Bumiputra', { ns: TRANSLATION_FILES.translation })}
                                style={{ margin: 'auto 1em' }}
                                toggle
                              />
                            </Dropdown.Item>
                          )
                        }
                        <Dropdown.Item
                          name="streetNumberOrLevel"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('streetNumberOrLevel')}
                            label={this.props.t('Level/Street Number', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="zoneOrBlock"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('zoneOrBlock')}
                            label={this.props.t('Block/Zone', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="streetOrFacing"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('streetOrFacing')}
                            label={this.props.t('Facing/Street', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="position"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('position')}
                            label={this.props.t('Position')}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="address"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('address')}
                            label={this.props.t('Address')}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="remarkExternal"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('remarkExternal')}
                            label={this.props.t('Public Notes', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="remarkInternal"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('remarkInternal')}
                            label={this.props.t('Internal Notes', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="packagePricings"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('packagePricings')}
                            label={this.props.t('Pricing Package')}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="specifications"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('specifications')}
                            label={this.props.t('Specification', { ns: TRANSLATION_FILES.translation })}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        <Dropdown.Item
                          name="agency"
                          onClick={this.handleVisibleCheckboxChange}
                        >
                          <Checkbox
                            checked={this.checkIfColumnVisible('agency')}
                            label={this.props.t('Agency')}
                            style={{ margin: 'auto 1em' }}
                            toggle
                          />
                        </Dropdown.Item>
                        { this.hasVAEnabled() &&
                          <Dropdown.Item
                            name="vaBankName"
                            onClick={this.handleVisibleCheckboxChange}
                          >
                            <Checkbox
                              checked={this.checkIfColumnVisible('vaBankName')}
                              label={this.props.t('VA Bank Name', { ns: TRANSLATION_FILES.translation })}
                              style={{ margin: 'auto 1em' }}
                              toggle
                            />
                          </Dropdown.Item>
                        }
                        { this.hasVAEnabled() &&
                          <Dropdown.Item
                            name="vaAccountNumber"
                            onClick={this.handleVisibleCheckboxChange}
                          >
                            <Checkbox
                              checked={this.checkIfColumnVisible('vaAccountNumber')}
                              label={this.props.t('VA Account Number', { ns: TRANSLATION_FILES.translation })}
                              style={{ margin: 'auto 1em' }}
                              toggle
                            />
                          </Dropdown.Item>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                    <Menu.Item className="no-menu-right-border">
                      <Dropdown
                        fluid
                        onChange={(e, data) => { this.handleTriggerCheck('handleChangeLimit', e, data); }}
                        options={this.getPageLimits()}
                        selection
                        selectOnBlur={false}
                        className="filterContainer"
                        value={this.state.pageLimit}
                      />
                      <div className="filterContainer">
                        <BookingSelectListMultiple
                          filterName="filterUnitLevel"
                          onChange={this.handleFilterOnChange}
                          options={this.SEARCH_UNITLEVEL}
                          placeholder={this.props.t('Select Level', { ns: TRANSLATION_FILES.translation })}
                          value={this.state.filterUnitLevel || []}
                          selectedText={this.props.t('level selected', { ns: TRANSLATION_FILES.translation })}
                        />
                      </div>
                      <div className="filterContainer">
                        <BookingSelectListMultiple
                          filterName="filterUnitLayoutID"
                          onChange={this.handleFilterOnChange}
                          options={this.SEARCH_UNITLAYOUTS}
                          placeholder={this.props.t('Select Type', { ns: TRANSLATION_FILES.translation })}
                          value={this.state.filterUnitLayoutID || []}
                          selectedText={this.props.t('type selected', { ns: TRANSLATION_FILES.translation })}
                        />
                      </div>
                      <div className="filterContainer">
                        <BookingSelectListMultiple
                          filterName="companyBranchID"
                          onChange={this.handleFilterOnChange}
                          options={
                            this.SEARCH_COMPANY_BRANCH.map(x => ({
                              value: x.value.toString(),
                              text: x.text,
                            }))
                          }
                          placeholder={this.props.t('Select Agency')}
                          value={this.state.companyBranchID || []}
                          selectedText={this.props.t('agency selected', { ns: TRANSLATION_FILES.translation })}
                        />
                      </div>
                      <div className="filterContainer">
                        <BookingSelectListMultiple
                          filterName="statusID"
                          onChange={this.handleFilterOnChange}
                          options={this.SEARCH_STATUSES.map(x => ({
                            ...x,
                            text: t(x.text, { ns: TRANSLATION_FILES.constants }),
                          }))}
                          placeholder={t('Select Status')}
                          value={this.state.statusID || []}
                          selectedText={t('status selected', { ns: TRANSLATION_FILES.translation })}
                        />
                      </div>
                    </Menu.Item>
                    <Menu.Menu position="right" className="right-menu">
                      <Menu.Item>
                        {
                          canClearAllocations && (
                            <div className="filterContainer">
                              <Button
                                negative
                                onClick={this.handleClearAllocations}
                                type="button"
                              >
                                <Icon name="unlock" />{t('Release all', { ns: TRANSLATION_FILES.translation })}
                              </Button>
                            </div>
                          )
                        }
                        <div className="filterContainer">
                          <Button
                            positive
                            onClick={this.handleManageAllocate}
                            type="button"
                            disabled={!this.checkIfAnySelected()}
                          >
                            <Icon name="sitemap" />{this.props.t('Allocate', { ns: TRANSLATION_FILES.translation })}
                          </Button>
                        </div>
                        <SearchMultiUnits
                          searchOnSubmit={search => this.handleTriggerCheck('handleSearchOnSubmit', search)}
                          searchValue={this.state.search}
                          multiFilter
                        />
                      </Menu.Item>
                    </Menu.Menu>
                  </Menu>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ padding: '1em 0.5em 0em 0.5em' }}>
                <Grid.Column mobile={16} tablet={8} computer={8} verticalAlign="middle">
                  {this.getCountSummaryText()}
                </Grid.Column>
                <Grid.Column
                  mobile={16}
                  tablet={8}
                  computer={8}
                  textAlign="right"
                  verticalAlign="middle"
                  className="multi-edit-actions"
                >
                  <Button
                    primary
                    icon
                    disabled={!this.checkIfAnySelected()}
                    onClick={this.handleEditRow}
                    type="button"
                    style={{ marginRight: '1em' }}
                  >
                    <Icon name="pencil" />&nbsp;{this.props.t('Edit')}
                  </Button>
                  <Button
                    disabled={!this.checkIfAnySelected()}
                    icon
                    onClick={this.handleResetRow}
                    primary
                    type="button"
                    style={{ marginRight: '1em' }}
                  >
                    <Icon name="undo" />&nbsp;{this.props.t('Reset', { ns: TRANSLATION_FILES.translation })}
                  </Button>
                  <Button
                    positive
                    icon
                    floated="right"
                    type="button"
                    onClick={this.handleUpdateUnits}
                  >
                    <Icon name="save" />&nbsp;{this.props.t('Update', { ns: TRANSLATION_FILES.translation })}
                  </Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <div
                    className={`multi-edit-top-scoll-bar ${this.state.isOver ? 'fixed' : ''}`}
                    id="tableTopScrollBar"
                    style={this.state.isOver && this.state.navHeight ?
                      { top: this.state.navHeight } : undefined}
                  >
                    <div style={{ width: this.state.tableWidth, height: '1px' }} />
                  </div>
                  <div style={{ overflowX: 'scroll' }} id="tableBottomScrollBar">
                    <Table
                      celled
                      className="multi-edit-table"
                      compact
                      sortable
                      structured
                      unstackable
                      id="multi-edit-table"
                    >
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell
                            onClick={(e) => {
                              if (rowsData.length > 0) this.handleCheckboxSelectAll(e);
                            }}
                          >
                            <Checkbox
                              checked={this.state.isSelectedAll}
                              disabled={rowsData.length < 1}
                            />
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            sorted={this.cellCheckSorted('reference')}
                            onClick={() => this.handleCellSort('reference')}
                          >
                            {this.props.t('Unit Reference', { ns: TRANSLATION_FILES.translation })}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            sorted={this.cellCheckSorted('projectUnitLayoutID')}
                            onClick={() => this.handleCellSort('projectUnitLayoutID')}
                          >
                            {this.props.t('Layout Type')}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            sorted={this.cellCheckSorted('statusID')}
                            onClick={() => this.handleCellSort('statusID')}
                          >
                            {this.props.t('Status')}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            sorted={this.cellCheckSorted('size')}
                            onClick={() => this.handleCellSort('size')}
                          >
                            {this.props.t('Size')}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            sorted={this.cellCheckSorted('spaAmount')}
                            onClick={() => this.handleCellSort('spaAmount')}
                          >
                            {
                              globalSettings && globalSettings.sellingPrice
                                ? globalSettings.sellingPrice
                                : this.props.t('Selling Price')
                            }
                          </Table.HeaderCell>
                          { isMalaysia && this.checkIfColumnVisible('isBumi') &&
                            <Table.HeaderCell
                              sorted={this.cellCheckSorted('isBumi')}
                              onClick={() => this.handleCellSort('isBumi')}
                            >
                              {this.props.t('Bumiputra', { ns: TRANSLATION_FILES.translation })}
                            </Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('streetNumberOrLevel') &&
                            <Table.HeaderCell
                              sorted={this.cellCheckSorted('streetNumberOrLevel')}
                              onClick={() => this.handleCellSort('streetNumberOrLevel')}
                            >
                              {this.props.t('Level/Street Number', { ns: TRANSLATION_FILES.translation })}
                            </Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('zoneOrBlock') &&
                            <Table.HeaderCell
                              sorted={this.cellCheckSorted('zoneOrBlock')}
                              onClick={() => this.handleCellSort('zoneOrBlock')}
                            >
                              {this.props.t('Block/Zone', { ns: TRANSLATION_FILES.translation })}
                            </Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('streetOrFacing') &&
                            <Table.HeaderCell
                              sorted={this.cellCheckSorted('streetOrFacing')}
                              onClick={() => this.handleCellSort('streetOrFacing')}
                            >
                              {this.props.t('Facing/Street', { ns: TRANSLATION_FILES.translation })}
                            </Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('position') &&
                            <Table.HeaderCell
                              sorted={this.cellCheckSorted('position')}
                              onClick={() => this.handleCellSort('position')}
                            >
                              {this.props.t('Position')}
                            </Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('address') &&
                            <Table.HeaderCell>{this.props.t('Address')}</Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('remarkExternal') &&
                            <Table.HeaderCell>{this.props.t('Public Notes', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('remarkInternal') &&
                            <Table.HeaderCell>{this.props.t('Internal Notes', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('packagePricings') &&
                            <Table.HeaderCell>{this.props.t('Pricing Package')}</Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('specifications') &&
                            <Table.HeaderCell>{this.props.t('Specification', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                          }
                          { this.checkIfColumnVisible('agency') &&
                            <Table.HeaderCell>{this.props.t('Agency')}</Table.HeaderCell>
                          }
                          { this.hasVAEnabled() && this.checkIfColumnVisible('vaBankName') &&
                            <Table.HeaderCell>{this.props.t('VA Bank Name', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                          }
                          { this.hasVAEnabled() && this.checkIfColumnVisible('vaAccountNumber') &&
                            <Table.HeaderCell>{this.props.t('VA Account Number', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
                          }
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {
                          rowsData.map.length > 0 ?
                          rowsData.map((column, idx) => (
                            <Table.Row
                              key={idx}
                              active={column.isSelected}
                              className={this.getRowClassName(column.isSelected, column.rowID)}
                            >
                              <Table.Cell onClick={e => this.handleCheckboxClick(e, column.rowID)} className="clickable">
                                <Checkbox
                                  checked={column.isSelected}
                                  name="isSelected"
                                />
                              </Table.Cell>
                              <Table.Cell>
                                <Grid>
                                  <Grid.Row style={{ padding: '0' }}>
                                    <Grid.Column width={column.errors.reference !== '' ? '11' : '12'}>
                                      <AppForm.Validate
                                        hideMessage
                                        onChange={
                                          (e, data) => this.handleInputChange(e, data, column.rowID)
                                        }
                                        onError={(hasError, msg) => this.handleOnError(hasError, msg, 'reference', column.rowID)}
                                        ref={this.validation[`reference${column.rowID}`]}
                                        validateLabel="Unit Reference"
                                        validation={[required]}
                                      >
                                        <Input
                                          action
                                          className="reference"
                                          fluid
                                          name="reference"
                                          onChange={
                                            (e, data) =>
                                            this.handleInputChange(e, data, column.rowID)
                                          }
                                          ref={(ref) => { this[`reference${column.rowID}`] = ref; }}
                                          value={column.reference}
                                          disabled={!allowEditUnitDetails}
                                        >
                                          <input />
                                          <a
                                            href={`/projects/${column.projectID}/units/${column.id}/`}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                          >
                                            <Button
                                              color="teal"
                                              icon={<Icon name="external" fitted />}
                                            />
                                          </a>
                                        </Input>
                                      </AppForm.Validate>
                                    </Grid.Column>
                                    {
                                      column.errors.reference !== '' ?
                                        <Grid.Column width="1" verticalAlign="middle">
                                          <Popup
                                            content={column.errors.reference}
                                            inverted
                                            size="mini"
                                            trigger={
                                              <Icon
                                                color="red"
                                                fitted
                                                name="warning sign"
                                                style={{ marginLeft: '1em' }}
                                              />
                                            }
                                          />
                                        </Grid.Column>
                                      : ''
                                    }
                                  </Grid.Row>
                                </Grid>
                              </Table.Cell>
                              <Table.Cell>
                                <Dropdown
                                  style={{ width: '12em' }}
                                  name="projectUnitLayoutID"
                                  fluid
                                  onChange={
                                    (e, data) => this.handleInputChange(e, data, column.rowID)
                                  }
                                  options={this.state.unitLayouts}
                                  selection
                                  selectOnBlur={false}
                                  value={column.projectUnitLayoutID}
                                  disabled={!allowEditUnitDetails}
                                />
                              </Table.Cell>
                              <Table.Cell>
                                <Dropdown
                                  fluid
                                  name="statusID"
                                  disabled={this.checkRestrictedStatusID(column.statusID) || !allowEditUnitDetails}
                                  onChange={
                                    (e, data) => !this.checkRestrictedStatusID(column.statusID) &&
                                    this.handleInputChange(e, data, column.rowID)
                                  }
                                  options={(this.checkRestrictedStatusID(column.statusID)
                                    ? UNIT_STATUSES_HQ_ALL
                                    : UNIT_STATUSES_EXTERNAL_ALL
                                  ).map(x => ({
                                    ...x,
                                    text: t(x.text, { ns: TRANSLATION_FILES.constants }),
                                  }))}
                                  selection
                                  selectOnBlur={false}
                                  value={column.statusID}
                                />
                              </Table.Cell>
                              <Table.Cell>
                                <AppForm.Validate
                                  hideMessage
                                  onChange={
                                    (e, data) => this.handleInputChange(e, data, column.rowID)
                                  }
                                  onError={(hasError, msg) => this.handleOnError(hasError, msg, 'size', column.rowID)}
                                  ref={this.validation[`size${column.rowID}`]}
                                  style={{ display: 'inline' }}
                                  validateLabel="Size"
                                  validation={[required, {
                                    validate: numericRange,
                                    option: {
                                      min: 0,
                                      max: 2147483647,
                                    },
                                  }]}
                                >
                                  <Input
                                    className="size"
                                    name="size"
                                    labelPosition={column.errors.size !== '' ? 'right' : null}
                                    ref={(ref) => { this[`size${column.rowID}`] = ref; }}
                                    type="number"
                                    min="0"
                                    step="0.0001"
                                    value={column.size}
                                    disabled={!allowEditUnitDetails}
                                  >
                                    <input />
                                    {
                                      column.errors.size !== '' ?
                                        <Label>
                                          <Popup
                                            content={column.errors.size}
                                            inverted
                                            size="mini"
                                            trigger={
                                              <Icon
                                                color="red"
                                                fitted
                                                name="warning sign"
                                                style={{ marginLeft: '0.5em' }}
                                              />
                                            }
                                          />
                                        </Label>
                                      : false
                                    }
                                  </Input>
                                </AppForm.Validate>
                              </Table.Cell>
                              <Table.Cell>
                                <AppForm.Validate
                                  hideMessage
                                  onChange={
                                    (e, data) => this.handleInputChange(e, data, column.rowID)
                                  }
                                  onError={(hasError, msg) => this.handleOnError(hasError, msg, 'spaAmount', column.rowID)}
                                  ref={this.validation[`spaAmount${column.rowID}`]}
                                  style={{ display: 'inline' }}
                                  validateLabel="Selling Price"
                                  validation={[required, {
                                    validate: numericRange,
                                    option: {
                                      min: 1,
                                      max: 2147483647,
                                    },
                                  }]}
                                >
                                  <Input
                                    className="spaAmount"
                                    disabled={this.checkRestrictedStatusID(column.statusID) || !allowEditUnitPrice}
                                    name="spaAmount"
                                    labelPosition={column.errors.spaAmount !== '' ? 'right' : null}
                                    ref={(ref) => { this[`spaAmount${column.rowID}`] = ref; }}
                                    type="number"
                                    step=".01"
                                    value={column.spaAmount}
                                  >
                                    <input />
                                    {
                                      column.errors.spaAmount !== '' ?
                                        <Label>
                                          <Popup
                                            content={column.errors.spaAmount}
                                            inverted
                                            size="mini"
                                            trigger={
                                              <Icon
                                                color="red"
                                                fitted
                                                name="warning sign"
                                                style={{ marginLeft: '0.5em' }}
                                              />
                                            }
                                          />
                                        </Label>
                                      : false
                                    }
                                  </Input>
                                </AppForm.Validate>
                              </Table.Cell>
                              { isMalaysia && this.checkIfColumnVisible('isBumi') &&
                                <Table.Cell textAlign="center">
                                  <Checkbox
                                    checked={column.isBumi}
                                    name="isBumi"
                                    onChange={
                                      (e, data) => this.handleCheckboxChange(e, data, column.rowID)
                                    }
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('streetNumberOrLevel') &&
                                <Table.Cell>
                                  <Input
                                    className="streetNumberOrLevel"
                                    name="streetNumberOrLevel"
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    value={column.streetNumberOrLevel}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('zoneOrBlock') &&
                                <Table.Cell>
                                  <Input
                                    className="zoneOrBlock"
                                    name="zoneOrBlock"
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    value={column.zoneOrBlock}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('streetOrFacing') &&
                                <Table.Cell>
                                  <Input
                                    className="streetOrFacing"
                                    name="streetOrFacing"
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    value={column.streetOrFacing}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('position') &&
                                <Table.Cell>
                                  <AppForm.Validate
                                    hideMessage
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    onError={(hasError, msg) => this.handleOnError(hasError, msg, 'position', column.rowID)}
                                    ref={this.validation[`position${column.rowID}`]}
                                    validateLabel="Position"
                                    validation={[required, {
                                      validate: numericRange,
                                      option: {
                                        min: 0,
                                      },
                                    }]}
                                  >
                                    <Input
                                      className="position"
                                      name="position"
                                      labelPosition={column.errors.position !== '' ? 'right' : null}
                                      ref={(ref) => { this[`position${column.rowID}`] = ref; }}
                                      type="number"
                                      value={column.position}
                                      disabled={!allowEditUnitDetails}
                                    >
                                      <input />
                                      {
                                        column.errors.position !== '' ?
                                          <Label>
                                            <Popup
                                              content={column.errors.position}
                                              inverted
                                              size="mini"
                                              trigger={
                                                <Icon
                                                  color="red"
                                                  fitted
                                                  name="warning sign"
                                                  style={{ marginLeft: '0.5em' }}
                                                />
                                              }
                                            />
                                          </Label>
                                        : false
                                      }
                                    </Input>
                                  </AppForm.Validate>
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('address') &&
                                <Table.Cell>
                                  <textarea
                                    className="semantic-textbox"
                                    name="address"
                                    onChange={e => this.handleTextAreaChange(e, column.rowID)}
                                    style={{ minHeight: '4em' }}
                                    value={column.address}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('remarkExternal') &&
                                <Table.Cell>
                                  <textarea
                                    className="semantic-textbox"
                                    name="remarkExternal"
                                    onChange={e => this.handleTextAreaChange(e, column.rowID)}
                                    style={{ minHeight: '4em' }}
                                    value={column.remarkExternal}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('remarkInternal') &&
                                <Table.Cell>
                                  <textarea
                                    className="semantic-textbox"
                                    name="remarkInternal"
                                    onChange={e => this.handleTextAreaChange(e, column.rowID)}
                                    style={{ minHeight: '4em' }}
                                    value={column.remarkInternal}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('packagePricings') &&
                                <Table.Cell singleLine>
                                  {
                                    allowEditUnitPrice ? (
                                      <Button
                                        onClick={
                                          e => this.handleManagePricing(e, column)
                                        }
                                        primary
                                        size="small"
                                      >
                                        {(column.projectUnitPackagePricings &&
                                          column.projectUnitPackagePricings.length
                                        ) > 0 ?
                                          this.props.t('Edit')
                                          : this.props.t('Add')
                                        }
                                      </Button>
                                    ) : null
                                  }
                                  { column.projectUnitPackagePricings ?
                                    column.projectUnitPackagePricings.map((price, idxs) => {
                                      if (price.totalPrice) {
                                        return (
                                          <span key={idxs}>
                                            {idxs > 0 && ' | '}<b>{price.projectPackagePricing && price.projectPackagePricing.name ? price.projectPackagePricing.name : price.customName || ''}:</b>&nbsp;
                                            <LoanAmount
                                              format="0,000,000.00"
                                              amount={price.totalPrice ? price.totalPrice : ''}
                                              precise={false}
                                            />
                                          </span>
                                        );
                                      }
                                      return '';
                                    })
                                    : null
                                  }
                                </Table.Cell>
                              }
                              { this.checkIfColumnVisible('specifications') &&
                                <Table.Cell singleLine>
                                  {
                                    allowEditUnitDetails ? (
                                      <Button
                                        onClick={
                                          e => this.handleManageSpecifications(e, column)
                                        }
                                        primary
                                        size="small"
                                      >
                                        {(column.specifications && column.specifications.length) > 0 ?
                                          this.props.t('Edit')
                                          : this.props.t('Add')
                                        }
                                      </Button>
                                    ) : null
                                  }
                                  { column.specifications ?
                                    column.specifications.map((spec, idxs) => (
                                      <span key={idxs}>
                                        {idxs > 0 && ' | '}<b>{spec.name}:</b> {spec.value}
                                      </span>
                                    ))
                                    : null
                                  }
                                </Table.Cell>
                              }
                              {
                              this.checkIfColumnVisible('agency') &&
                                <Table.Cell>
                                  <div className="agency-allocation-dropdown" style={{ width: '20em' }}>
                                    <Dropdown
                                      name="companyBranchAllocationIDs"
                                      onChange={
                                        (e, data) => this.handleInputChange(e, data, column.rowID)
                                      }
                                      placeholder={this.props.t('Select Agency')}
                                      fluid
                                      multiple
                                      search
                                      selection
                                      selectOnBlur={false}
                                      renderLabel={this.renderAgencyLabel}
                                      options={this.getAgencyAllocationOptions(
                                        column, companyBranches, agencyAllocationAllocateAll,
                                      )}
                                      value={this.getAgencyAllocationValue(
                                        column, agencyAllocationAllocateAll,
                                      )}
                                      disabled={!allowEditUnitDetails ||
                                        this.isAgencyAllocationLocked(column.statusID)}
                                    />
                                  </div>
                                </Table.Cell>
                              }
                              { this.hasVAEnabled() && this.checkIfColumnVisible('vaBankName') &&
                                <Table.Cell>
                                  <SelectBank
                                    style={{ width: '20em' }}
                                    country={company ? company.countryCode : ''}
                                    name="vaBankName"
                                    placeholder={this.props.t('Select Bank')}
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    value={column.vaBankName}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                              { this.hasVAEnabled() && this.checkIfColumnVisible('vaAccountNumber') &&
                                <Table.Cell>
                                  <Input
                                    className="vaAccountNumber"
                                    name="vaAccountNumber"
                                    onChange={
                                      (e, data) => this.handleInputChange(e, data, column.rowID)
                                    }
                                    value={column.vaAccountNumber}
                                    disabled={!allowEditUnitDetails}
                                  />
                                </Table.Cell>
                              }
                            </Table.Row>
                          ))
                          : null
                        }
                      </Table.Body>
                    </Table>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ padding: '0em 0.5em' }}>
                <Grid.Column>
                  {this.getCountSummaryText()}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ textAlign: 'center' }}>
                <Grid.Column>
                  <div style={{ marginRight: '1em' }}>
                    <PageNav
                      count={this.state.count}
                      currentPage={this.state.currentPage}
                      dataSize={rowsData.length}
                      limit={this.state.limit}
                      loading={this.state.loading}
                      offset={this.state.offset}
                      onChange={page => this.handleTriggerCheck('handleChangePage', page)}
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(connect(MultiEdit.mapStateToProps)(MultiEdit));



// WEBPACK FOOTER //
// ./src/containers/Project/MultiUnits/Edit.jsx